import * as XLSX from 'xlsx';

const getWorkBook = <T>(data: T[], header: string[]) => {
  const worksheet = XLSX.utils.json_to_sheet(data, { header });
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  return workbook;
};

export const downLoadFile = <T>(
  data: T[],
  header: string[],
  filename: string,
) => {
  const workbook = getWorkBook(data, header);

  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
